import { JsonObject } from '../../helpers';
import { ConnectorApiKeyConfig, ConnectorFeatureSet } from './';
import BraveAPIIcon from '@/assets/connector-icons/brave-api.png';
import { ConnectorModel } from './connector.model';

export class BraveAPIConnectorModel extends ConnectorModel {
  config: ConnectorApiKeyConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'brave-search';
    this.typeLabel = 'Brave Search API';
    this.iconSVG = BraveAPIIcon;

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: false,
      contextData: true,
      ingress: false,
    };

    this.config = (data.config as ConnectorApiKeyConfig) || {
      apiKey: '',
    };

    this.configSecrets = ['apiKey'];

    this.contextProviderTypes = ['customer-web-brave-search'];
  }
}
